module.exports = __webpack_public_path__ + "static/fastlink-10a9a46727c78c6191096dbf3f77e7bf.jpg";